import { motion, useScroll, useTransform } from 'framer-motion';
import { Plane } from 'lucide-react';

const NavbarProgressBar = () => {
  const { scrollYProgress } = useScroll();
  const widthTransform = useTransform(scrollYProgress, [0, 1], ['0%', '100%']);

  return (
    <div className="absolute bottom-0 left-0 right-0 h-[5px] bg-teal-100/20 overflow-visible">
      <motion.div
        style={{ width: widthTransform }}
        className="h-full bg-[#067978] relative overflow-visible shadow-[0_0_10px_rgba(6,121,120,0.6)]"
      >
        <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 z-30 flex items-center justify-center bg-white border-2 border-[#067978] rounded-full w-6 h-6 shadow-[0_2px_8px_rgba(6,121,120,0.4)] hover:scale-110 transition-all duration-200">
          <Plane size={13} className="text-[#067978] rotate-90" />
        </div>
      </motion.div>
    </div>
  );
};

export default NavbarProgressBar;
